import { FunctionComponent } from 'react';
import styles from './TransactionsEmpty.module.css';
import { Button } from 'components/UI';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleDollar } from '@fortawesome/pro-regular-svg-icons';

interface TransactionsEmptyProps {
    onPay: () => void;
}

export const TransactionsEmpty: FunctionComponent<TransactionsEmptyProps> = props => (
    <div className={styles.container}>
        <div className={styles.iconContainer}>
            <FontAwesomeIcon
                icon={faCircleDollar}
                className={styles.icon}
            />
        </div>
        <h1 className={styles.title}>No transactions recorded yet</h1>
        <p className={styles.description}>Once payments are made for this booking, they&rsquo;ll appear here.</p>
        <Button
            color="black"
            variant="primary"
            label="Pay"
            className={styles.button}
            onClick={() => props.onPay()}
        />
    </div>
);

export default TransactionsEmpty;
